module.exports = "<p>\n  register works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/register/register.component.html
// module id = ./src/app/components/account/register/register.component.html
// module chunks = main